import { gql } from "@apollo/client";

export const GET_ALL_MENUS = gql`
  query getAllMenus {
    menus {
      _id
      cook {
        _id
        fullName
      }
      dish {
        _id
        dishName
        dishPhoto
        allergens
        calories {
          min
          max
        }
      }
      menuDate
    }
  }
`

export const GET_ALL_SIGNUPS = gql`
  query getAllSignups {
    signups {
      user {
        _id
        fullName
        zone
      }
      menuItem {
        _id
        dish {
          dishName
          dishPhoto
          allergens
          calories {
            min
            max
          }
        }
        menuDate
      }
      size
    }
  }
`

export const GET_USER_SIGNUPS = gql`
  query getUserSignups {
    userSignups {
      _id
      user {
        fullName
      }
      menuItem {
        _id
        dish {
          dishName
          dishPhoto
          allergens
          calories {
            min
            max
          }
        }
        menuDate
      }
      size
    }
  }
`

export const GET_OPEN_MENUS_ON_CLICK = gql`
  query getOpenMenusOnClick($number: String) {
    openMenusOnClick(number: $number) {
      _id
      cook {
        _id
        fullName
      }
      dish {
        _id
        dishName
        dishPhoto
        allergens
        calories {
          min
          max
        }
      }
      menuDate
      amount
    }
  }
`

export const GET_USER_SIGNUPS_ON_CLICK = gql`
  query getUserSignupsOnClick($number: String) {
    userSignupsOnClick(number: $number) {
       _id
      user {
        fullName
      }
      menuItem {
        _id
        dish {
          dishName
          dishPhoto
          allergens
          calories {
            min
            max
          }
        }
        menuDate
      }
      size
    }
  }
`

export const GET_SIGNUPS_FOR_MENU_ITEM = gql`
  query getSignupsForMenuItem($menuId: ID!) {
    getSignupsForMenuItem(menuId: $menuId) {
      menuItem {
        _id
        cook {
          fullName
        }
        dish {
          dishName
        }
        menuDate
      }
      size
      user {
        _id
        fullName
        zone
      }
    }
  }
`

export const GET_FOR_ALL_MENUS = gql`
  query getForAllMenus {
    forAllMenus {
      _id
      cook {
        _id
        fullName
      }
      dish {
        _id
        dishName
        dishPhoto
        allergens
        calories {
          min
          max
        }
      }
      menuDate
      amount
      forAll
    }
  }
`

export const GET_FOR_ALL_USER_SIGNUPS = gql`
  query getForAllUserSignups {
    forAllUserSignups {
      _id
      user {
        fullName
      }
      menuItem {
        _id
        dish {
          dishName
          dishPhoto
          allergens
          calories {
            min
            max
          }
        }
        menuDate
        forAll
      }
      size
    }
  }
`

export const GET_FMB_ITEM_MENUS = gql`
  query getFmbItemMenus {
    fmbItemMenus {
      _id
      cook {
        _id
        fullName
      }
      dish {
        _id
        dishName
        dishPhoto
        allergens
        calories {
          min
          max
        }
      }
      menuDate
      amount
      fmbItem
    }
  }
`

export const GET_FMB_ITEM_USER_SIGNUPS = gql`
  query getFmbItemUserSignups {
    fmbItemUserSignups {
      _id
      user {
        fullName
      }
      menuItem {
        _id
        dish {
          dishName
          dishPhoto
          allergens
          calories {
            min
            max
          }
        }
        menuDate
        fmbItem
      }
      size
    }
  }
`